/**
 * Sujets d'aide du bouton « ? » (miroir de App\Constants\HelpContexts côté API).
 * Un sujet regroupe une tâche : il peut apparaître sur plusieurs écrans.
 * L'ordre est celui de la page Formation.
 */
export const HELP_CONTEXT_PURCHASES_ORDERS = "purchases-orders";
export const HELP_CONTEXT_PURCHASES_ORDER_RECEPTION =
  "purchases-order-reception";
export const HELP_CONTEXT_SALES_ORDERS = "sales-orders";
export const HELP_CONTEXT_CASH_REGISTER_READINGS = "cash-register-readings";
export const HELP_CONTEXT_INVENTORY = "inventory";
export const HELP_CONTEXT_INTERNAL_ORDERS = "internal-orders";
export const HELP_CONTEXT_ESTABLISHMENT_TRANSFERS = "establishment-transfers";
export const HELP_CONTEXT_INTERNAL_INVOICES = "internal-invoices";
export const HELP_CONTEXT_WEEKLY_REPORTS = "weekly-reports";

export const HELP_CONTEXTS = [
  HELP_CONTEXT_PURCHASES_ORDERS,
  HELP_CONTEXT_PURCHASES_ORDER_RECEPTION,
  HELP_CONTEXT_SALES_ORDERS,
  HELP_CONTEXT_CASH_REGISTER_READINGS,
  HELP_CONTEXT_INVENTORY,
  HELP_CONTEXT_INTERNAL_ORDERS,
  HELP_CONTEXT_ESTABLISHMENT_TRANSFERS,
  HELP_CONTEXT_INTERNAL_INVOICES,
  HELP_CONTEXT_WEEKLY_REPORTS,
];

/** Clé i18n du libellé d'un sujet (suffix « _WHERE » : écrans où il apparaît). */
export function helpContextI18nKey(context, suffix = "") {
  return `TRAININGS.CONTEXT_${context
    .toUpperCase()
    .replace(/-/g, "_")}${suffix}`;
}
